import { render, staticRenderFns } from "./BatchInformation.vue?vue&type=template&id=5c62c31c&scoped=true&"
import script from "./BatchInformation.vue?vue&type=script&lang=ts&"
export * from "./BatchInformation.vue?vue&type=script&lang=ts&"
import style0 from "./BatchInformation.vue?vue&type=style&index=0&id=5c62c31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62c31c",
  null
  
)

export default component.exports